import { useState } from 'react'
import { applyDiscount } from './discounts'
import './App.css'

const items = [
  { name: 'Wireless Mouse', price: 25, emoji: '🖱️', colour: '#dbeafe' },
  { name: 'Keyboard', price: 45, emoji: '⌨️', colour: '#fce7f3' },
  { name: 'USB-C Hub', price: 30, emoji: '🔌', colour: '#dcfce7' },
]

const subtotal = items.reduce((sum, item) => sum + item.price, 0)

function App() {
  const [code, setCode] = useState('')
  const [total, setTotal] = useState(subtotal)

  function handleApply() {
    setTotal(applyDiscount(code, subtotal))
  }

  return (
    <div className="page">
      <header className="store-header">
        <span className="store-logo" aria-hidden="true">
          ◆
        </span>
        <span className="store-name">Gadget Shop</span>
        <span className="store-step">Checkout</span>
      </header>

      <main className="checkout">
        <section className="card items-card" aria-labelledby="cart-heading">
          <h2 id="cart-heading">Your cart</h2>
          <ul className="line-items">
            {items.map((item) => (
              <li key={item.name} className="line-item">
                <span
                  className="item-tile"
                  style={{ background: item.colour }}
                  aria-hidden="true"
                >
                  {item.emoji}
                </span>
                <span className="item-name">{item.name}</span>
                <span className="item-price">${item.price.toFixed(2)}</span>
              </li>
            ))}
          </ul>
        </section>

        <section className="card summary-card" aria-labelledby="summary-heading">
          <h1 id="summary-heading">Order summary</h1>
          <p className="summary-row">Subtotal: ${subtotal.toFixed(2)}</p>
          <p className="summary-row">Shipping: Free</p>
          <div className="discount">
            <label htmlFor="discount-code">Discount code</label>
            <div className="discount-field">
              <input
                id="discount-code"
                value={code}
                placeholder="e.g. WELCOME10"
                onChange={(event) => setCode(event.target.value)}
              />
              <button type="button" onClick={handleApply}>
                Apply
              </button>
            </div>
          </div>
          <p className="summary-total">Total: ${total.toFixed(2)}</p>
          <button type="button" className="place-order" disabled>
            Place order
          </button>
          <p className="demo-note">Demo store: no payments taken</p>
        </section>
      </main>
    </div>
  )
}

export default App
